"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useFluidPlayer = void 0;

var _react = require("react");

var _VideoController = require("./controllers/VideoController");

var _PlaylistController = require("./controllers/PlaylistController");

var _VideoInfoMonitor = require("./VideoInfoMonitor");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var useFluidPlayer = function useFluidPlayer(ref) {
  var updateOpts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  var _useState = (0, _react.useState)(0),
      _useState2 = _slicedToArray(_useState, 2),
      rev = _useState2[0],
      setRev = _useState2[1];

  var _useState3 = (0, _react.useState)(null),
      _useState4 = _slicedToArray(_useState3, 2),
      videoController = _useState4[0],
      setVideoController = _useState4[1];

  var _useState5 = (0, _react.useState)(null),
      _useState6 = _slicedToArray(_useState5, 2),
      playlistController = _useState6[0],
      setPlaylistController = _useState6[1];

  var _useState7 = (0, _react.useState)(null),
      _useState8 = _slicedToArray(_useState7, 2),
      videoInfoMonitor = _useState8[0],
      setVideoInfoMonitor = _useState8[1];

  (0, _react.useEffect)(function () {
    if (ref) {
      setVideoController(_VideoController.VideoController.getInstance(ref.current));
      setPlaylistController(_PlaylistController.PlaylistController.getInstance(ref.current));
      var monitor = new _VideoInfoMonitor.VideoInfoMonitor(ref, null, updateOpts);
      setVideoInfoMonitor(monitor);
    }

    return function () {
      if (videoInfoMonitor) {
        videoInfoMonitor.destroy();
      }
    };
  }, []);
  (0, _react.useEffect)(function () {
    var handlePlaylistControllerUpdates = function handlePlaylistControllerUpdates(e) {
      console.log("useFluidPlayer: playlist controller updated");
      setRev(rev + 1);
    };

    document.addEventListener("trc-playlist-changed-".concat(ref.current), handlePlaylistControllerUpdates);
    return function () {
      document.removeEventListener("trc-playlist-changed-".concat(ref.current), handlePlaylistControllerUpdates);
    };
  }, [rev]);
  var controls = (0, _react.useMemo)(function () {
    var play = function play() {
      if (videoController) {
        videoController.onPlay();
      } else {
        document.dispatchEvent(new CustomEvent("trc-play"));
      }
    };

    var pause = function pause() {
      if (videoController) {
        videoController.onPause();
      } else {
        document.dispatchEvent(new CustomEvent("trc-pause"));
      }
    };

    var jump = function jump(to) {
      if (playlistController) {
        playlistController.jump(to);
      } else {
        console.warn("useFluidPlayerControls: jump called without controller, ignoring");
      }
    };

    var jumpForward = function jumpForward() {
      var amt = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 5;

      if (playlistController) {
        playlistController.jumpAhead(amt);
      } else {
        console.warn("useFluidPlayerControls: jumpForward called without controller, ignoring");
      }
    };

    var jumpBack = function jumpBack() {
      var amt = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 5;

      if (playlistController) {
        playlistController.jumpBack(amt);
      } else {
        console.warn("useFluidPlayerControls: jumpBack called without controller, ignoring");
      }
    };

    var toggleMulticam = function toggleMulticam(e) {
      if (videoController) {
        videoController.toggleMulticam(e);
      } else {
        document.dispatchEvent(new CustomEvent("trc-multicam-toggle"));
      }
    };

    var selectCamera = function selectCamera(camera) {
      if (videoController) {
        videoController.selectCamera(camera);
      } else {
        console.warn("useFluidPlayControls: selectCamera called without controller, ignoring");
      }
    };

    var onItemChanged = function onItemChanged(handle) {
      if (playlistController) {
        playlistController.onItemChanged = handle;
      } else {
        console.warn("useFluidPlayControls: onItemChanged called without controller, ignoring");
      }
    };

    var goToNext = function goToNext() {
      if (playlistController) {
        playlistController.goToNext();
        setRev(rev + 1);
      } else {
        console.warn("useFluidPlayControls: goToNext called without controller, ignoring");
      }
    };

    var goToPrev = function goToPrev() {
      if (playlistController) {
        playlistController.goToPrev();
        setRev(rev + 1);
      } else {
        console.warn("useFluidPlayControls: goToPrev called without controller, ignoring");
      }
    };

    var goToItem = function goToItem(id) {
      if (playlistController) {
        playlistController.goToItem(id);
        setRev(rev + 1);
      } else {
        console.warn("useFluidPlayControls: goToItem called without controller, ignoring");
      }
    };

    var goToNextTouch = function goToNextTouch(t) {
      if (playlistController) {
        playlistController.goToNextTouch(t);
        setRev(rev + 1);
      } else {
        console.warn("useFluidPlayControls: goToNextTouch called without controller, ignoring");
      }
    };

    var setItems = function setItems(items, initialId) {
      if (playlistController) {
        var change = playlistController.setItems(items, initialId);

        if (change) {
          setRev(rev + 1);
        }
      } else {
        throw "Cannot set items when playlist controller is null";
      }
    };

    var setItemsAndSources = function setItemsAndSources(fluidSources, items, initialId, camera) {
      var time = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : null;

      if (playlistController) {
        var change = playlistController.setSourcesAndItems(fluidSources, items, initialId, camera, time);

        if (change) {
          setRev(rev + 1);
        }
      } else {
        throw "Cannot set items and sources when playlist controller is null";
      }
    };

    var setTouches = function setTouches(items) {
      if (playlistController) {
        var change = playlistController.getTouchesFromMoments(items);

        if (change) {
          setRev(rev + 1);
        }
      }
    };

    var handleVideoInfoUpdate = function handleVideoInfoUpdate(handler) {
      if (videoInfoMonitor) {
        videoInfoMonitor._onChange = handler;
      } else {
        console.warn("useFluidPlayControls: handleVideoInfoUpdate called without monitor, ignoring");
      }
    };

    var getVideoInfo = function getVideoInfo() {
      if (videoController) {
        return videoController.buildVideoInfo();
      } else {
        return null;
      }
    };

    return {
      play: play,
      pause: pause,
      jump: jump,
      jumpForward: jumpForward,
      jumpBack: jumpBack,
      toggleMulticam: toggleMulticam,
      selectCamera: selectCamera,
      onItemChanged: onItemChanged,
      goToNext: goToNext,
      goToPrev: goToPrev,
      goToItem: goToItem,
      goToNextTouch: goToNextTouch,
      setItems: setItems,
      setItemsAndSources: setItemsAndSources,
      setTouches: setTouches,
      getVideoInfo: getVideoInfo,
      handleVideoInfoUpdate: handleVideoInfoUpdate,
      monitor: videoInfoMonitor,
      videoController: videoController,
      playlistController: playlistController
    };
  }, [videoController, playlistController]);
  var activeFluidSources = playlistController === null || playlistController === void 0 ? void 0 : playlistController.activeFluidSources();

  if (!activeFluidSources) {
    activeFluidSources = [];
  }

  var mainFluidSources = playlistController === null || playlistController === void 0 ? void 0 : playlistController.mainFluidSources();

  if (!mainFluidSources) {
    mainFluidSources = [];
  }

  var insideMoment = playlistController === null || playlistController === void 0 ? void 0 : playlistController.insideMoment;
  return _objectSpread({
    currentMoment: playlistController === null || playlistController === void 0 ? void 0 : playlistController.currentMoment,
    fluidSources: playlistController === null || playlistController === void 0 ? void 0 : playlistController.fluidSources,
    fluidSourcesInfo: {
      firstActiveFluidSource: playlistController === null || playlistController === void 0 ? void 0 : playlistController.firstActiveFluidSource(),
      lastActiveFluidSource: playlistController === null || playlistController === void 0 ? void 0 : playlistController.lastActiveFluidSource(),
      activeFluidSources: activeFluidSources,
      firstMainFluidSource: playlistController === null || playlistController === void 0 ? void 0 : playlistController.firstMainFluidSource(),
      lastMainFluidSource: playlistController === null || playlistController === void 0 ? void 0 : playlistController.lastMainFluidSource(),
      mainFluidSources: mainFluidSources
    },
    fluidSource: playlistController === null || playlistController === void 0 ? void 0 : playlistController.fluidSource,
    insideMoment: insideMoment,
    items: playlistController === null || playlistController === void 0 ? void 0 : playlistController.items
  }, controls);
};

exports.useFluidPlayer = useFluidPlayer;